import { AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moments from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UsersettingService } from 'src/app/services/usersetting.service';
import { ValidationService } from 'src/app/services/validation.service';
import { CommonService } from '../../services/common.service';
import * as moment from 'moment-timezone';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { AnyAaaaRecord } from 'dns';
declare var $: any;
import { environment } from '../../../environments/environment';
import { AgmMap, MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit, AfterViewInit {
  envData: any = environment;
  form:FormGroup;
  userData:any ;
  modelForm:FormGroup;
  todate = '';
  fromdate = '';
  dealerId = '';
  pageOption = 10;
  pageOptionModal = 10;
  page: number = 1;
  submitted = false;
  userId = localStorage.getItem('userId');
  customerList = [];
  addCustomerForm: any;
  editCustomerForm: FormGroup;
  timezoneArray = [];
  currentUrl= {
    name:'',
    isDealer:false,
    pageLable:''
  }
  orgId:any;
  currentUser= {
    name:'',
    isUser:false,
    pageLable:''
  }

  
  notificationsMasterList= [];
  TimezoneArray = [
    {id: 1, country: 'Dubai', tz: 'Asia/Dubai'},
    {id: 2, country: 'Kabul', tz: 'Asia/Kabul'},
    {id: 3, country: 'Yerevan', tz: 'Asia/Yerevan'},
    {id: 4, country: 'Baku', tz: 'Asia/Baku'},
    {id: 5, country: 'Dhaka', tz: 'Asia/Dhaka'},
    {id: 6, country: 'Brunei', tz: 'Asia/Brunei'},
    {id: 7, country: 'Thimphu', tz: 'Asia/Thimphu'},
    {id: 8, country: 'Shanghai', tz: 'Asia/Shanghai'},
    {id: 9, country: 'Urumqi', tz: 'Asia/Urumqi'},
    {id: 10, country: 'Nicosia', tz: 'Asia/Nicosia'},
    {id: 11, country: 'Famagusta', tz: 'Asia/Famagusta'},
    {id: 12, country: 'Tbilisi', tz: 'Asia/Tbilisi'},
    {id: 13, country: 'Hong_Kong', tz: 'Asia/Hong_Kong'},
    {id: 14, country: 'Jakarta', tz: 'Asia/Jakarta'},
    {id: 15, country: 'Pontianak', tz: 'Asia/Pontianak'},
    {id: 16, country: 'Makassar', tz: 'Asia/Makassar'},
    {id: 17, country: 'Jayapura', tz: 'Asia/Jayapura'},
    {id: 18, country: 'Jerusalem', tz: 'Asia/Jerusalem'},
    {id: 19, country: 'Kolkata', tz: 'Asia/Kolkata'},
    {id: 20, country: 'Baghdad', tz: 'Asia/Baghdad'},
    {id: 21, country: 'Tehran', tz: 'Asia/Tehran'},
    {id: 22, country: 'Amman', tz: 'Asia/Amman'},
    {id: 23, country: 'Tokyo', tz: 'Asia/Tokyo'},
    {id: 24, country: 'Bishkek', tz: 'Asia/Bishkek'},
    {id: 25, country: 'Pyongyang', tz: 'Asia/Pyongyang'},
    {id: 26, country: 'Seoul', tz: 'Asia/Seoul'},
    {id: 27, country: 'Almaty', tz: 'Asia/Almaty'},
    {id: 28, country: 'Qyzylorda', tz: 'Asia/Qyzylorda'},
    {id: 29, country: 'Qostanay', tz: 'Asia/Qostanay'},
    {id: 30, country: 'Aqtobe', tz: 'Asia/Aqtobe'},
    {id: 31, country: 'Aqtau', tz: 'Asia/Aqtau'},
    {id: 32, country: 'Atyrau', tz: 'Asia/Atyrau'},
    {id: 33, country: 'Oral', tz: 'Asia/Oral'},
    {id: 34, country: 'Beirut', tz: 'Asia/Beirut'},
    {id: 35, country: 'Colombo', tz: 'Asia/Colombo'},
    {id: 36, country: 'Yangon', tz: 'Asia/Yangon'},
    {id: 37, country: 'Ulaanbaatar', tz: 'Asia/Ulaanbaatar'},
    {id: 38, country: 'Hovd', tz: 'Asia/Hovd'},
    {id: 39, country: 'Choibalsan', tz: 'Asia/Choibalsan'},
    {id: 40, country: 'Macau', tz: 'Asia/Macau'},
    {id: 41, country: 'Kuala_Lumpur', tz: 'Asia/Kuala_Lumpur'},
    {id: 42, country: 'Kuching', tz: 'Asia/Kuching'},
    {id: 43, country: 'Karachi', tz: 'Asia/Karachi'},
    {id: 44, country: 'Gaza', tz: 'Asia/Gaza'},
    {id: 45, country: 'Hebron', tz: 'Asia/Hebron'},
    {id: 46, country: 'Kathmandu', tz: 'Asia/Kathmandu'},
    {id: 47, country: 'Yekaterinburg', tz: 'Asia/Yekaterinburg'},
    {id: 48, country: 'Qatar', tz: 'Asia/Qatar'},
    {id: 49, country: 'Omsk', tz: 'Asia/Omsk'},
    {id: 50, country: 'Novosibirsk', tz: 'Asia/Novosibirsk'},
    {id: 51, country: 'Barnaul', tz: 'Asia/Barnaul'},
    {id: 52, country: 'Tomsk', tz: 'Asia/Tomsk'},
    {id: 53, country: 'Novokuznetsk', tz: 'Asia/Novokuznetsk'},
    {id: 54, country: 'Krasnoyarsk', tz: 'Asia/Krasnoyarsk'},
    {id: 55, country: 'Irkutsk', tz: 'Asia/Irkutsk'},
    {id: 56, country: 'Chita', tz: 'Asia/Chita'},
    {id: 57, country: 'Yakutsk', tz: 'Asia/Yakutsk'},
    {id: 58, country: 'Khandyga', tz: 'Asia/Khandyga'},
    {id: 59, country: 'Vladivostok', tz: 'Asia/Vladivostok'},
    {id: 60, country: 'Ust-Nera', tz: 'Asia/Ust-Nera'},
    {id: 61, country: 'Singapore', tz: 'Asia/Singapore'},
    {id: 62, country: 'Magadan', tz: 'Asia/Magadan'},
    {id: 63, country: 'Sakhalin', tz: 'Asia/Sakhalin'},
    {id: 64, country: 'Srednekolymsk', tz: 'Asia/Srednekolymsk'},
    {id: 65, country: 'Kamchatka', tz: 'Asia/Kamchatka'},
    {id: 66, country: 'Anadyr', tz: 'Asia/Anadyr'},
    {id: 67, country: 'Bangkok', tz: 'Asia/Bangkok'},
    {id: 68, country: 'Dushanbe', tz: 'Asia/Dushanbe'},
    {id: 69, country: 'Taipei', tz: 'Asia/Taipei'},
    {id: 70, country: 'Dili', tz: 'Asia/Dili'},
    {id: 71, country: 'Ashgabat', tz: 'Asia/Ashgabat'},
    {id: 72, country: 'Damascus', tz: 'Asia/Damascus'},
    {id: 73, country: 'Riyadh', tz: 'Asia/Riyadh'},
    {id: 74, country: 'Samarkand', tz: 'Asia/Samarkand'},
    {id: 75, country: 'Tashkent', tz: 'Asia/Tashkent'},
    {id: 76, country: 'Ho_Chi_Minh', tz: 'Asia/Ho_Chi_Minh'},
    // {id: 77, country: 'Andorra', tz: 'Europe/Andorra'},
    // {id: 78, country: 'Tirane', tz: 'Europe/Tirane'},
    // {id: 79, country: 'Vienna', tz: 'Europe/Vienna'},
    // {id: 80, country: 'Brussels', tz: 'Europe/Brussels'},
    // {id: 81, country: 'Sofia', tz: 'Europe/Sofia'},
    // {id: 82, country: 'Minsk', tz: 'Europe/Minsk'},
    // {id: 83, country: 'Zurich', tz: 'Europe/Zurich'},
    // {id: 84, country: 'Prague', tz: 'Europe/Prague'},
    // {id: 85, country: 'Berlin', tz: 'Europe/Berlin'},
    // {id: 86, country: 'Copenhagen', tz: 'Europe/Copenhagen'},
    // {id: 87, country: 'Tallinn', tz: 'Europe/Tallinn'},
    // {id: 88, country: 'Madrid', tz: 'Europe/Madrid'},
    // {id: 89, country: 'Helsinki', tz: 'Europe/Helsinki'},
    // {id: 90, country: 'Paris', tz: 'Europe/Paris'},
    // {id: 91, country: 'London', tz: 'Europe/London'},
    // {id: 92, country: 'Gibraltar', tz: 'Europe/Gibraltar'},
    // {id: 93, country: 'Athens', tz: 'Europe/Athens'},
    // {id: 94, country: 'Budapest', tz: 'Europe/Budapest'},
    // {id: 95, country: 'Dublin', tz: 'Europe/Dublin'},
    // {id: 96, country: 'Rome', tz: 'Europe/Rome'},
    // {id: 97, country: 'Vilnius', tz: 'Europe/Vilnius'},
    // {id: 98, country: 'Luxembourg', tz: 'Europe/Luxembourg'},
    // {id: 99, country: 'Riga', tz: 'Europe/Riga'},
    // {id: 100, country: 'Monaco', tz: 'Europe/Monaco'},
    // {id: 101, country: 'Chisinau', tz: 'Europe/Chisinau'},
    // {id: 102, country: 'Malta', tz: 'Europe/Malta'},
    // {id: 103, country: 'Amsterdam', tz: 'Europe/Amsterdam'},
    // {id: 104, country: 'Oslo', tz: 'Europe/Oslo'},
    // {id: 105, country: 'Warsaw', tz: 'Europe/Warsaw'},
    // {id: 106, country: 'Warsaw', tz: 'Europe/Warsaw'},
    // {id: 107, country: 'Lisbon', tz: 'Europe/Lisbon'},
    // {id: 108, country: 'Bucharest', tz: 'Europe/Bucharest'},
    // {id: 109, country: 'Belgrade', tz: 'Europe/Belgrade'},
    // {id: 110, country: 'Kaliningrad', tz: 'Europe/Kaliningrad'},
    // {id: 111, country: 'Moscow', tz: 'Europe/Moscow'},
    // {id: 112, country: 'Simferopol', tz: 'Europe/Simferopol'},
    // {id: 113, country: 'Kirov', tz: 'Europe/Kirov'},
    // {id: 114, country: 'Astrakhan', tz: 'Europe/Astrakhan'},
    // {id: 115, country: 'Volgograd', tz: 'Europe/Volgograd'},
    // {id: 116, country: 'Saratov', tz: 'Europe/Saratov'},
    // {id: 117, country: 'Ulyanovsk', tz: 'Europe/Ulyanovsk'},
    // {id: 118, country: 'Samara', tz: 'Europe/Samara'},
    // {id: 119, country: 'Stockholm', tz: 'Europe/Stockholm'},
    // {id: 120, country: 'Istanbul', tz: 'Europe/Istanbul'},
    // {id: 121, country: 'Kiev', tz: 'Europe/Kiev'},
    // {id: 122, country: 'Uzhgorod', tz: 'Europe/Uzhgorod'},
    // {id: 123, country: 'Zaporozhye', tz: 'Europe/Zaporozhye'},
    // {id: 124, country: 'Buenos_Aires', tz: 'America/Argentina/Buenos_Aires'},
    // {id: 125, country: 'Cordoba', tz: 'America/Argentina/Cordoba'},
    // {id: 126, country: 'Salta', tz: 'America/Argentina/Salta'},
    // {id: 127, country: 'Jujuy', tz: 'America/Argentina/Jujuy'},
    // {id: 128, country: 'Tucuman', tz: 'America/Argentina/Tucuman'},
    // {id: 129, country: 'Catamarca', tz: 'America/Argentina/Catamarca'},
    // {id: 130, country: 'La_Rioja', tz: 'America/Argentina/La_Rioja'},
    // {id: 131, country: 'San_Juan', tz: 'America/Argentina/San_Juan'},
    // {id: 132, country: 'Mendoza', tz: 'America/Argentina/Mendoza'},
    // {id: 133, country: 'San_Luis', tz: 'America/Argentina/San_Luis'},
    // {id: 134, country: 'Rio_Gallegos', tz: 'America/Argentina/Rio_Gallegos'},
    // {id: 135, country: 'Ushuaia', tz: 'America/Argentina/Ushuaia'},
    // {id: 136, country: 'Barbados', tz: 'America/Barbados'},
    // {id: 137, country: 'La_Paz', tz: 'America/La_Paz'},
    // {id: 138, country: 'Belem', tz: 'America/Belem'},
    // {id: 139, country: 'Fortaleza', tz: 'America/Fortaleza'},
    // {id: 140, country: 'Recife', tz: 'America/Recife'},
    // {id: 18, country: 'Araguaina', tz: 'America/Araguaina'},
    // {id: 19, country: 'Maceio', tz: 'America/Maceio'},
    // {id: 20, country: 'Bahia', tz: 'America/Bahia'},
    // {id: 21, country: 'Sao_Paulo', tz: 'America/Sao_Paulo'},
    // {id: 22, country: 'Campo_Grande', tz: 'America/Campo_Grande'},
    // {id: 23, country: 'Cuiaba', tz: 'America/Cuiaba'},
    // {id: 24, country: 'Porto_Velho', tz: 'America/Porto_Velho'},
    // {id: 25, country: 'Boa_Vista', tz: 'America/Boa_Vista'},
    // {id: 26, country: 'Manaus', tz: 'America/Manaus'},
    // {id: 27, country: 'Eirunepe', tz: 'America/Eirunepe'},
    // {id: 28, country: 'Rio_Branco', tz: 'America/Rio_Branco'},
    // {id: 29, country: 'Nassau', tz: 'America/Nassau'},
    // {id: 30, country: 'Belize', tz: 'America/Belize'},
    // {id: 31, country: 'St_Johns', tz: 'America/St_Johns'},
    {id: 142, country: 'India', tz: 'Asia/Calcutta'},
  ];

  documentList = [
    {
      docId: 'Adhar',
      docName: 'Adhar Card',
    },
    {
      docId: 'voterCard',
      docName: 'Voter Id',
    },
    {
      docId: 'PAN',
      docName: 'Pan Card',
    },
    {
      docId: 'DL',
      docName: 'Driving License',
    },
    {
      docId: 'Nepali Citizenship',
      docName: 'Nepali Citizenship',
    },
  ];

  attrList: any = [
    {
      id: 'notificationTokens',
      name: 'Notification Tokens',
      type: 'text',
    },
    {
      id: 'currency',
      name: 'Currency',
      type: 'text',
    },
    {
      id: 'unitprice',
      name: 'Unit Price',
      type: 'number',
    },
    {
      id: 'managerEmailAddress',
      name: 'Manager Email Address',
      type: 'text',
    },
    {
      id: 'managerContactNumber',
      name: 'Manager Contact Number',
      type: 'text',
    },
    
            
  ];
  addAttr: any = {
    attribute: '',
    type: '',
    value: null,
  };
  deviceList: any = [];
  errors: any = {};
  superAdmin:boolean = false;
  modalRef?: BsModalRef;
  usersList = [];
  @Input()
  addMode = false;
  @Input()
  gridMode = false;
  @Input()
  viewMode = false;
  isFirstTime = false;
  timeZoneList: any[] = ["Africa/Abidjan","Africa/Algiers","Africa/Bissau","Africa/Cairo","Africa/Casablanca","Africa/Ceuta","Africa/El_Aaiun","Africa/Johannesburg","Africa/Juba","Africa/Khartoum","Africa/Lagos","Africa/Maputo","Africa/Monrovia","Africa/Nairobi","Africa/Ndjamena","Africa/Sao_Tome","Africa/Tripoli","Africa/Tunis","Africa/Windhoek","America/Adak","America/Anchorage","America/Araguaina","America/Argentina/Buenos_Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La_Rioja","America/Argentina/Mendoza","America/Argentina/Rio_Gallegos","America/Argentina/Salta","America/Argentina/San_Juan","America/Argentina/San_Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Asuncion","America/Bahia","America/Bahia_Banderas","America/Barbados","America/Belem","America/Belize","America/Boa_Vista","America/Bogota","America/Boise","America/Cambridge_Bay","America/Campo_Grande","America/Cancun","America/Caracas","America/Cayenne","America/Chicago","America/Chihuahua","America/Ciudad_Juarez","America/Costa_Rica","America/Cuiaba","America/Danmarkshavn","America/Dawson","America/Dawson_Creek","America/Denver","America/Detroit","America/Edmonton","America/Eirunepe","America/El_Salvador","America/Fort_Nelson","America/Fortaleza","America/Glace_Bay","America/Goose_Bay","America/Grand_Turk","America/Guatemala","America/Guayaquil","America/Guyana","America/Halifax","America/Havana","America/Hermosillo","America/Indiana/Indianapolis","America/Indiana/Knox","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Tell_City","America/Indiana/Vevay","America/Indiana/Vincennes","America/Indiana/Winamac","America/Inuvik","America/Iqaluit","America/Jamaica","America/Juneau","America/Kentucky/Louisville","America/Kentucky/Monticello","America/La_Paz","America/Lima","America/Los_Angeles","America/Maceio","America/Managua","America/Manaus","America/Martinique","America/Matamoros","America/Mazatlan","America/Menominee","America/Merida","America/Metlakatla","America/Mexico_City","America/Miquelon","America/Moncton","America/Monterrey","America/Montevideo","America/New_York","America/Nome","America/Noronha","America/North_Dakota/Beulah","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/Nuuk","America/Ojinaga","America/Panama","America/Paramaribo","America/Phoenix","America/Port-au-Prince","America/Porto_Velho","America/Puerto_Rico","America/Punta_Arenas","America/Rankin_Inlet","America/Recife","America/Regina","America/Resolute","America/Rio_Branco","America/Santarem","America/Santiago","America/Santo_Domingo","America/Sao_Paulo","America/Scoresbysund","America/Sitka","America/St_Johns","America/Swift_Current","America/Tegucigalpa","America/Thule","America/Tijuana","America/Toronto","America/Vancouver","America/Whitehorse","America/Winnipeg","America/Yakutat","Antarctica/Casey","Antarctica/Davis","Antarctica/Macquarie","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Troll","Asia/Almaty","Asia/Amman","Asia/Anadyr","Asia/Aqtau","Asia/Aqtobe","Asia/Ashgabat","Asia/Atyrau","Asia/Baghdad","Asia/Baku","Asia/Bangkok","Asia/Barnaul","Asia/Beirut","Asia/Bishkek","Asia/Chita","Asia/Choibalsan","Asia/Colombo","Asia/Damascus","Asia/Dhaka","Asia/Dili","Asia/Dubai","Asia/Dushanbe","Asia/Famagusta","Asia/Gaza","Asia/Hebron","Asia/Ho_Chi_Minh","Asia/Hong_Kong","Asia/Hovd","Asia/Irkutsk","Asia/Jakarta","Asia/Jayapura","Asia/Jerusalem","Asia/Kabul","Asia/Kamchatka","Asia/Karachi","Asia/Kathmandu","Asia/Khandyga","Asia/Kolkata","Asia/Krasnoyarsk","Asia/Kuching","Asia/Macau","Asia/Magadan","Asia/Makassar","Asia/Manila","Asia/Nicosia","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Omsk","Asia/Oral","Asia/Pontianak","Asia/Pyongyang","Asia/Qatar","Asia/Qostanay","Asia/Qyzylorda","Asia/Riyadh","Asia/Sakhalin","Asia/Samarkand","Asia/Seoul","Asia/Shanghai","Asia/Singapore","Asia/Srednekolymsk","Asia/Taipei","Asia/Tashkent","Asia/Tbilisi","Asia/Tehran","Asia/Thimphu","Asia/Tokyo","Asia/Tomsk","Asia/Ulaanbaatar","Asia/Urumqi","Asia/Ust-Nera","Asia/Vladivostok","Asia/Yakutsk","Asia/Yangon","Asia/Yekaterinburg","Asia/Yerevan","Atlantic/Azores","Atlantic/Bermuda","Atlantic/Canary","Atlantic/Cape_Verde","Atlantic/Faroe","Atlantic/Madeira","Atlantic/South_Georgia","Atlantic/Stanley","Australia/Adelaide","Australia/Brisbane","Australia/Broken_Hill","Australia/Darwin","Australia/Eucla","Australia/Hobart","Australia/Lindeman","Australia/Lord_Howe","Australia/Melbourne","Australia/Perth","Australia/Sydney","CET","CST6CDT","EET","EST","EST5EDT","Etc/GMT","Etc/GMT+1","Etc/GMT+10","Etc/GMT+11","Etc/GMT+12","Etc/GMT+2","Etc/GMT+3","Etc/GMT+4","Etc/GMT+5","Etc/GMT+6","Etc/GMT+7","Etc/GMT+8","Etc/GMT+9","Etc/GMT-1","Etc/GMT-10","Etc/GMT-11","Etc/GMT-12","Etc/GMT-13","Etc/GMT-14","Etc/GMT-2","Etc/GMT-3","Etc/GMT-4","Etc/GMT-5","Etc/GMT-6","Etc/GMT-7","Etc/GMT-8","Etc/GMT-9","Etc/UTC","Europe/Andorra","Europe/Astrakhan","Europe/Athens","Europe/Belgrade","Europe/Berlin","Europe/Brussels","Europe/Bucharest","Europe/Budapest","Europe/Chisinau","Europe/Dublin","Europe/Gibraltar","Europe/Helsinki","Europe/Istanbul","Europe/Kaliningrad","Europe/Kirov","Europe/Kyiv","Europe/Lisbon","Europe/London","Europe/Madrid","Europe/Malta","Europe/Minsk","Europe/Moscow","Europe/Paris","Europe/Prague","Europe/Riga","Europe/Rome","Europe/Samara","Europe/Saratov","Europe/Simferopol","Europe/Sofia","Europe/Tallinn","Europe/Tirane","Europe/Ulyanovsk","Europe/Vienna","Europe/Vilnius","Europe/Volgograd","Europe/Warsaw","Europe/Zurich","HST","Indian/Chagos","Indian/Maldives","Indian/Mauritius","MET","MST","MST7MDT","PST8PDT","Pacific/Apia","Pacific/Auckland","Pacific/Bougainville","Pacific/Chatham","Pacific/Easter","Pacific/Efate","Pacific/Fakaofo","Pacific/Fiji","Pacific/Galapagos","Pacific/Gambier","Pacific/Guadalcanal","Pacific/Guam","Pacific/Honolulu","Pacific/Kanton","Pacific/Kiritimati","Pacific/Kosrae","Pacific/Kwajalein","Pacific/Marquesas","Pacific/Nauru","Pacific/Niue","Pacific/Norfolk","Pacific/Noumea","Pacific/Pago_Pago","Pacific/Palau","Pacific/Pitcairn","Pacific/Port_Moresby","Pacific/Rarotonga","Pacific/Tahiti","Pacific/Tarawa","Pacific/Tongatapu","WET"];
  drivId: any = '';
  driverResponse: any;
  deviceResponse: any;
  addExtraValues:any = {
    cabno: '',
    vehicleno: '',
    lname: '',
    email: '',
    transporttype: '',
    transportdesc: '',
    vehiclecolor: '',
    vehiclelicenseplate: '',
    adharcardno: '',
    addressproof: '',
    medicalproof: '',
    policeverificationproof: '',
    registrationcertificateproof: '',
    taxcertificateproof: '',
    permitproof: '',
    insuranceproof: '',
    fitnessproof: '',
    pucproof: '',
    extradocsproof: '',
    taxcertificateexpirydt: '',
    permitexpirydt: '',
    insuranceexpirydt: '',
    fitnessexpirydt: '',
    pucexpirydt: '',
    medicalexpirydt: '',
    policeverificationexpirydt: '',
    drivername: '',
    driverdobdt: '',
    drivinglicenseno: '',
    drivinglicenseexpirydt: '',
    vendorname: '',
    companyname: '',
    packagetype: '',
    totaltripkm: '',
    driverphotoproof: ''
  };
  @ViewChild('search') 
  searchElementRef: ElementRef;
  @ViewChild('mapslocation') 
  mapslocation: AgmMap;
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  constructor(
    private modalService: BsModalService,
    private user: UsersettingService,
    private fb: FormBuilder,
    private customValidator: ValidationService,
    private commonService: CommonService,
    private router:Router,
    private route:ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    this.commonService.pageLoadInModal.subscribe((result: string) => {
      console.log('pagemodel=>',result)
      if (result == "clients-notuse") {        
        this.currentUrl.isDealer = false;
        this.gridMode = true;
        this.addMode = false;
        this.viewMode = false;
        if (!this.isFirstTime) {
          this.isFirstTime = true;
          this.customerList = [];
          this.resetExtraFields();
          this.initialize();
          this.ngOnInit();
        }
        
      } else if (result == "clients") {        
        this.currentUrl.isDealer = true;
        this.gridMode = true;
        this.addMode = false;
        this.viewMode = false;
        if (!this.isFirstTime) {
          this.isFirstTime = true;
          this.customerList = [];
          this.resetExtraFields();
          this.initialize();
          this.ngOnInit();          
        }
        
      }      
      
    });
    // let currentUrl = window.location.href;
    // this.currentUrl.isDealer = currentUrl.indexOf('dealers') != -1;
     
    this.addCustomerForm = {
      id: null,
      name: '',
      // lastname: ['', Validators.required],
      // usernumber: ['', Validators.required],
      email: '',
      password: '',
      deviceLimit: '0',
      userLimit: '0',
      attributesList:[],
      attributes: {
        speedUnit:'',
        distanceUnit:'',
        altitudeUnit:'',
        volumeUnit:'',
        timezone: ''
        }
    };
    
    this.editCustomerForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      userids: ['', Validators.required],
      expdate: ['', Validators.required],
      addresss: ['', Validators.required],
      emailid: ['', Validators.required],
      phonenumber: ['', Validators.required],
    });

    
  }
  initialize() {
    if(this.currentUrl.isDealer ) {
      this.currentUrl.name = 'Clients';
    }else 
    {
      this.currentUrl.name = 'Customer';
    }
    //this.getTimezoneList();
  }

  resetExtraFields() {
    this.addExtraValues = {
      cabno: '',
      vehicleno: '',
      lname: '',
      email: '',
      transporttype: '',
      transportdesc: '',
      vehiclecolor: '',
      vehiclelicenseplate: '',
      adharcardno: '',
      addressproof: '',
      medicalproof: '',
      policeverificationproof: '',
      registrationcertificateproof: '',
      taxcertificateproof: '',
      permitproof: '',
      insuranceproof: '',
      fitnessproof: '',
      pucproof: '',
      extradocsproof: '',
      taxcertificateexpirydt: '',
      permitexpirydt: '',
      insuranceexpirydt: '',
      fitnessexpirydt: '',
      pucexpirydt: '',
      medicalexpirydt: '',
      policeverificationexpirydt: '',
      drivername: '',
      driverdobdt: '',
      drivinglicenseno: '',
      drivinglicenseexpirydt: '',
      vendorname: '',
      companyname: '',
      packagetype: '',
      totaltripkm: '',
      driverphotoproof: ''
    };
  }
  ngOnInit(): void {
   console.log('clients component')
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
        this.superAdmin = this.userData && this.userData.administrator;
        if(this.userData.attributes.role === 'admin'){
       this.orgId=this.userData.id;
      }
      else{
        this.orgId = this.userData.orgId;
      }
      } catch (error) {}
    }
    
    this.form = new FormGroup({
      searchValue: new FormControl(''),
     
    });
    this.modelForm = new FormGroup({
      searchValue: new FormControl(''),
     
    });
    this.getAllCustomers();
    var timeZones = moment.tz.names();
    this.timezoneArray = [];
    for (var i in timeZones) {
      this.timezoneArray.push({
        viewValue:
          '(GMT' + moment.tz(timeZones[i]).format('Z') + ')' + timeZones[i],
        value: timeZones[i],
      });
    }

    this.zoom = 4;
    this.latitude = 39.8282;
    this.longitude = -98.5795;

    //create search FormControl
    this.searchControl = new FormControl();

    //set current position
    this.setCurrentPosition();

    //load Places Autocomplete
    // this.mapsAPILoader.load().then(() => {
    //   let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
    //     types: ["address"]
    //   });
    //   autocomplete.addListener("place_changed", () => {
    //     this.ngZone.run(() => {
    //       //get the place result
    //       let place: google.maps.places.PlaceResult = autocomplete.getPlace();

    //       //verify result
    //       if (place.geometry === undefined || place.geometry === null) {
    //         return;
    //       }

    //       //set latitude, longitude and zoom
    //       this.latitude = place.geometry.location.lat();
    //       this.longitude = place.geometry.location.lng();
    //       this.zoom = 12;
    //     });
    //   });
    // });
  }

 
searchData(){

}
loginToUser(user) {
  this.commonService.otherUserLogin(user.id,this.userData.id);
}
  getAllCustomers() {
   this.commonService.getRequest(`users?orgId=${this.orgId}`, []).then((resp: any) => {
      if (resp?.status) {
        this.customerList = resp.data;
        this.usersList = this.customerList.filter(customer=>!customer.administrator && customer.userLimit === 0); 
        if(this.currentUrl.isDealer) {
          this.customerList = this.customerList.filter(customer=> customer.attributes?.role == 'clients');
        }else  {
    
          this.customerList = this.customerList.filter(customer=> customer.attributes?.role == 'driver');
        
        }
      }
    });

// old code
    // this.user.getCustomers().subscribe(resp => {
    //   this.customerList = resp;
    // })
    //console.log("Customer api called");
    // this.commonService.getRequest('users', []).then((resp: any) => {
    //   if (resp?.status) {
    //     this.customerList = resp.data;
    //     this.usersList = this.customerList.filter(customer=>!customer.administrator && customer.userLimit === 0); 
    //     if(this.currentUrl.isDealer) {
    //       this.customerList = this.customerList.filter(customer=> customer.attributes?.role == 'clients');
    //     }else {
    //       this.customerList = this.customerList.filter(customer=> customer.attributes?.role == 'driver');
    //     }
    //   }
    // });
  }
  
  onCustomerSubmit() {

    this.errors = {};
    let error = false;
    this.submitted = true;
    if (!this.addCustomerForm.name) {
      this.errors['name'] = 'This field is required';
      error = true;
    }
    if (!this.addCustomerForm.email) {
      this.errors['email'] = 'This field is required';
      error = true;
    }
    if (!this.addCustomerForm.id && !this.addCustomerForm.password) {
      this.errors['password'] = 'This field is required';
      error = true;
    }

    console.log('this.addCustomerForm', this.addCustomerForm);

    let dataSet = {
      name: this.addCustomerForm.name,
      email: this.addCustomerForm.email,
      phone: this.addCustomerForm.phone,
      deviceLimit: this.addCustomerForm.deviceLimit,
      userLimit: this.addCustomerForm.userLimit,
      // expirationTime: moments(this.addCustomerForm.expirationTime).format(),
      attributes: this.addCustomerForm.attributes,
      orgId:  this.orgId,
    };

    if (!error) {
      if (this.addCustomerForm.readonly) {
        dataSet['readonly'] = true;
      }
      if (this.addCustomerForm.limitCommands) {
        dataSet['limitCommands'] = true;
      }
      if (this.addCustomerForm.disableReports) {
        dataSet['disableReports'] = true;
      }
      if (this.addCustomerForm.deviceReadonly) {
        dataSet['deviceReadonly'] = true;
      }
      if (this.addCustomerForm.administrator) {
        dataSet['administrator'] = true;
      }
      if (this.addCustomerForm.disabled) {
        dataSet['disabled'] = true;
      }

      if (this.addCustomerForm?.attributesList?.length) {
        this.addCustomerForm.attributesList.forEach((a) => {
          switch (a.attribute) {
            case 'notificationTokens':
              dataSet.attributes['notificationTokens'] = a.value;
              break;
            case 'unitprice':
              dataSet.attributes['unitprice'] = a.value;
              break;
            case 'currency':
              dataSet.attributes['currency'] = a.value;
              break;
            case 'managerEmailAddress':
              dataSet.attributes['managerEmailAddress'] = a.value;
              break;
            case 'managerContactNumber':
              dataSet.attributes['managerContactNumber'] = a.value;
              break;
          }
        });
      }
    }

    if (this.addCustomerForm.id && !error) {
      dataSet['id'] = this.addCustomerForm.id;
      if (this.addCustomerForm.password) {
        dataSet['password'] = this.addCustomerForm.password;
      }
      if (this.currentUrl.isDealer) {
        dataSet.attributes['role'] = 'clients';        
      } 
      else {
        dataSet.attributes['role'] = 'driver';
        dataSet.attributes['status'] = 'offline';
        dataSet.attributes['did'] = this.addCustomerForm.email;
        dataSet.attributes = {...dataSet.attributes, ...this.addExtraValues};
      }
      dataSet.attributes['location'] = {lat: this.latitude, lon: this.longitude};
      this.commonService
        .putRequest('users/' + this.addCustomerForm.id, dataSet)
        .then((resp: any) => {
          if (resp?.status && resp?.data?.id) {
            //$('#staticBackdrop').modal('hide');
            this.gridMode = true;
            this.addMode = false;
            this.viewMode = false;
            Swal.fire({
              icon: 'success',
              title: this.currentUrl.isDealer? 'Driver': 'Supervisor' +' saved successfully.',
              showConfirmButton: false,
              timer: 1500,
            });
            //this.searchControl.patchValue('');
            this.getAllCustomers();
          }
        },(err)=>{
          console.log(err);
           Swal.fire({
             icon: "error",
             title: "Something Went Wrong",
             showConfirmButton: false,
             timer: 1500,
           });
         });
    } else if (!error) {
      dataSet['password'] = this.addCustomerForm.password;
      if (this.currentUrl.isDealer) {
        dataSet.attributes['role'] = 'clients';
      } 
      else {
        dataSet.attributes['role'] = 'driver';
        dataSet.attributes['status'] = 'offline';
        dataSet.attributes['did'] = this.addCustomerForm.email;
        dataSet.attributes = {...dataSet.attributes, ...this.addExtraValues};
      }
      dataSet.attributes['location'] = {lat: this.latitude, lon: this.longitude};
      this.commonService.postRequest('users', dataSet).then((resp: any) => {
        if (resp?.status && resp?.data?.id) {
          //$('#staticBackdrop').modal('hide');
          if (this.currentUrl.isDealer) {
            this.gridMode = true;
            this.addMode = false;
            this.viewMode = false;
            Swal.fire({
              icon: 'success',
              title: 'Supervisor saved successfully.',
              showConfirmButton: false,
              timer: 1500,
            });
            //this.searchControl.patchValue('');
            this.getAllCustomers();

          } else {
          // this.gridMode = true;
          // this.addMode = false;
          // Swal.fire({
          //   icon: 'success',
          //   title: 'Driver saved successfully.',
          //   showConfirmButton: false,
          //   timer: 1500,
          // });
            this.driverResponse = resp?.data;
            this.deviceApiCall();
          }
          //this.getAllCustomers();
        }
      },(err)=>{
        console.log(err);
         Swal.fire({
           icon: "error",
           title: "Something Went Wrong",
           showConfirmButton: false,
           timer: 1500,
         });
       });
    }
  }

  deviceApiCall() {
    this.commonService
    .postRequest('devices', {
      name: this.driverResponse?.name,
      uniqueId: this.driverResponse?.id,
    })
    .then((resp: any) => {
      if (resp?.status) {
        // this.gridMode = true;
        // this.addMode = false;
        //this.getAllDevices();
        //$('#btnclose').click();
        this.deviceResponse = resp?.data;
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Your device saved successfully.',
        //   showConfirmButton: false,
        //   timer: 1500,
        // });        
        this.deviceUserMappingAPICall();
      }
    },(err)=>{
      console.log(err);
       Swal.fire({
         icon: "error",
         title: "Something Went Wrong",
         showConfirmButton: false,
         timer: 1500,
       });
     });
  }
  deviceUserMappingAPICall() {
    this.commonService
        .postRequest('permissions', {
          userId: this.driverResponse?.id,
          deviceId: this.deviceResponse?.id,
        })
        .then((resp: any) => {
          if (resp?.status) {
            this.gridMode = true;
            this.addMode = false;
            this.viewMode = false;
            Swal.fire({
              icon: 'success',
              title: 'Driver saved successfully.',
              showConfirmButton: false,
              timer: 1500,
            });
            this.deviceResponse = undefined;
            this.driverResponse = undefined;
            this.getAllCustomers();
          }
        });
  }
  onClickDelete(id) {
    Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this User!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.isConfirmed) {
        let body = {
          deleteuser: true,
          userId: id,
        };
        this.user.deleteCustomer(body).subscribe((resp) => {
          console.log(resp);
          this.gridMode = true;
          this.addMode = false;
          this.viewMode = false;
          this.getAllCustomers();
        });
        Swal.fire('Deleted!', 'User has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'User is safe :)', 'error');
      }
    });
  }

  onClickEdit(customer) {
    this.editCustomerForm.setValue({
      first_name: customer.first_name,
      last_name: customer.DealerDetails[0].last_name,
      userids: customer.user_id,
      expdate: customer.expire_date.split('T')[0],
      addresss: customer.address,
      emailid: customer.email,
      phonenumber: customer.phone,
    });
    this.dealerId = customer._id;
  }

  onEditCustomerSubmit() {
    let body = {
      address: this.editCustomerForm.value.addresss,
      contactid: this.dealerId,
      expire_date: this.editCustomerForm.value.expdate,
      first_name: this.editCustomerForm.value.first_name,
      last_name: this.editCustomerForm.value.last_name,
      user_id: this.editCustomerForm.value.userids,
      email: this.editCustomerForm.value.emailid,
      phone: this.editCustomerForm.value.phonenumber,
    };
    this.user.editCustomer(body).subscribe((resp) => {
      console.log(resp);
      //$('#staticBackdrop4').modal('hide');
      this.gridMode = true;
      this.addMode = false;
      this.viewMode = false;
      this.getAllCustomers();
    });
  }

  checkboxEvent(e: any, type: any) {
    this.addCustomerForm[type] = e.checked;
  }

  addUser() {
    this.gridMode = false;
    this.addMode = true;
    this.viewMode = false;
    let userTimeZone = moment.tz.guess();
    console.log(userTimeZone);
    let filterTimezone = this.TimezoneArray.find(tz=>tz.tz.toLowerCase() == userTimeZone.toLowerCase() );
    this.addCustomerForm = {
      id: null,
      name: '',
      email: '',
      password: '',
      phone:'',
      // expirationTime: new Date(),
      deviceLimit: 0,
      userLimit: 0,
      readonly: false,
      limitCommands: false,
      deviceReadonly: false,
      disableReports: false,
      administrator: false,
      disabled: false,
      attributesList:[],
      attributes: {
        speedUnit:'kmh',
        distanceUnit:'km',
        altitudeUnit:'m',
        volumeUnit:'ltr',
        timezone:filterTimezone ? filterTimezone.tz : ''
        },
    };
    this.findAdress();
    this.resizeMap();
    // this.addCustomerForm.controls.name.markAsUntouched();
    // this.addCustomerForm.controls.email.markAsUntouched();
    // this.addCustomerForm.controls.password.markAsUntouched();
    // this.addCustomerForm.controls.password.setValidators([Validators.required]);
    // this.addCustomerForm.controls.password.updateValueAndValidity();
  }
  viewUser(userData) {
    this.gridMode = false;
    this.addMode = false;
    this.viewMode = true;
    let user = JSON.parse(JSON.stringify(userData));
    this.addCustomerForm = {
      id: user.id,
      name: user.name,
      email: user.email,
      // expirationTime: moments(user.expirationTime).format('DD/MM/YYYY'),
      deviceLimit: user.deviceLimit,
      userLimit: user.userLimit,
      phone: user.phone,
      readonly: user.readonly,
      limitCommands: user.limitCommands,
      deviceReadonly: user.deviceReadonly,
      disableReports: user.disableReports,
      administrator: user.administrator,
      disabled: user.disabled,
      attributes: user.attributes,
      attributesList:[],

    };
      this.addCustomerForm.attributes = user.attributes ?user.attributes : {
        speedUnit:'kmh',
        distanceUnit:'km',
        altitudeUnit:'m',
        volumeUnit:'ltr',
        timezone:''
      };
      this.addCustomerForm.attributes['speedUnit'] = user.attributes && user.attributes.speedUnit ?user.attributes.speedUnit : '' ,
      this.addCustomerForm.attributes['distanceUnit'] = user.attributes && user.attributes.distanceUnit ?user.attributes.distanceUnit : '' ,
      this.addCustomerForm.attributes['altitudeUnit'] = user.attributes && user.attributes.altitudeUnit ?user.attributes.altitudeUnit : '' ,
      this.addCustomerForm.attributes['volumeUnit'] = user.attributes && user.attributes.volumeUnit ?user.attributes.volumeUnit : '' ,
      this.addCustomerForm.attributes['timezone'] = user.attributes && user.attributes.timezone ?user.attributes.timezone : '' 
    let attrLength = Object.keys(user.attributes);
    if (attrLength?.length) {
      attrLength.forEach((a) => {
        let dataSet = {
          attribute: '',
          type: '',
          value: null,
        };
        switch (a) {
          case 'notificationTokens':
            if (user.attributes[a]) {
              dataSet.attribute = 'notificationTokens';
              dataSet.type = 'number';
              dataSet.value = user.attributes[a];
              delete user.attributes[a];
            }
            break;
          case 'unitprice':
            if (user.attributes[a]) {
              dataSet.attribute = 'unitprice';
              dataSet.type = 'number';
              dataSet.value = user.attributes[a];
              delete user.attributes[a]
            }
            break;
          case 'currency':
            if (user.attributes[a]) {
              dataSet.attribute = 'currency';
              dataSet.type = 'string';
              dataSet.value = user.attributes[a];
              delete user.attributes[a]
            }
            break;
            case 'managerEmailAddress':
              if (user.attributes[a]) {
                dataSet.attribute = 'managerEmailAddress';
                dataSet.type = 'string';
                dataSet.value = user.attributes[a];
                delete user.attributes[a]
              }
              break;
            case 'managerContactNumber':
              if (user.attributes[a]) {
                dataSet.attribute = 'managerContactNumber';
                dataSet.type = 'string';
                dataSet.value = user.attributes[a];
                delete user.attributes[a]
              }
              break;
        }
        if (dataSet.attribute) {
          this.addCustomerForm.attributesList.push(dataSet);
        }
      });
    }
    this.latitude = user.attributes['location']?.lat;
    this.longitude = user.attributes['location']?.lon;
    this.searchControl.patchValue(this.latitude +', '+ this.longitude);
    this.addExtraValues = userData.attributes;
  }
  edtUser(userData) {
    this.gridMode = false;
    this.addMode = true;
    this.viewMode = false;
    let user = JSON.parse(JSON.stringify(userData));
    this.addCustomerForm = {
      id: user.id,
      name: user.name,
      email: user.email,
      // expirationTime: moments(user.expirationTime).format('DD/MM/YYYY'),
      deviceLimit: user.deviceLimit,
      userLimit: user.userLimit,
      phone: user.phone,
      readonly: user.readonly,
      limitCommands: user.limitCommands,
      deviceReadonly: user.deviceReadonly,
      disableReports: user.disableReports,
      administrator: user.administrator,
      disabled: user.disabled,
      attributes: user.attributes,
      attributesList:[],

    };
      this.addCustomerForm.attributes = user.attributes ?user.attributes : {
        speedUnit:'kmh',
        distanceUnit:'km',
        altitudeUnit:'m',
        volumeUnit:'ltr',
        timezone:''
      };
      this.addCustomerForm.attributes['speedUnit'] = user.attributes && user.attributes.speedUnit ?user.attributes.speedUnit : '' ,
      this.addCustomerForm.attributes['distanceUnit'] = user.attributes && user.attributes.distanceUnit ?user.attributes.distanceUnit : '' ,
      this.addCustomerForm.attributes['altitudeUnit'] = user.attributes && user.attributes.altitudeUnit ?user.attributes.altitudeUnit : '' ,
      this.addCustomerForm.attributes['volumeUnit'] = user.attributes && user.attributes.volumeUnit ?user.attributes.volumeUnit : '' ,
      this.addCustomerForm.attributes['timezone'] = user.attributes && user.attributes.timezone ?user.attributes.timezone : '' 
    let attrLength = Object.keys(user.attributes);
    if (attrLength?.length) {
      attrLength.forEach((a) => {
        let dataSet = {
          attribute: '',
          type: '',
          value: null,
        };
        switch (a) {
          case 'notificationTokens':
            if (user.attributes[a]) {
              dataSet.attribute = 'notificationTokens';
              dataSet.type = 'number';
              dataSet.value = user.attributes[a];
              delete user.attributes[a];
            }
            break;
          case 'unitprice':
            if (user.attributes[a]) {
              dataSet.attribute = 'unitprice';
              dataSet.type = 'number';
              dataSet.value = user.attributes[a];
              delete user.attributes[a]
            }
            break;
          case 'currency':
            if (user.attributes[a]) {
              dataSet.attribute = 'currency';
              dataSet.type = 'string';
              dataSet.value = user.attributes[a];
              delete user.attributes[a]
            }
            break;
            case 'managerEmailAddress':
              if (user.attributes[a]) {
                dataSet.attribute = 'managerEmailAddress';
                dataSet.type = 'string';
                dataSet.value = user.attributes[a];
                delete user.attributes[a]
              }
              break;
            case 'managerContactNumber':
              if (user.attributes[a]) {
                dataSet.attribute = 'managerContactNumber';
                dataSet.type = 'string';
                dataSet.value = user.attributes[a];
                delete user.attributes[a]
              }
              break;
        }
        if (dataSet.attribute) {
          this.addCustomerForm.attributesList.push(dataSet);
        }
      });
    }
    this.latitude = user.attributes['location']?.lat;
    this.longitude = user.attributes['location']?.lon;
    this.searchControl.patchValue(this.latitude +', '+ this.longitude);
    this.addExtraValues = userData.attributes;
    // this.addCustomerForm.controls.name.markAsUntouched();
    // this.addCustomerForm.controls.email.markAsUntouched();
    // this.addCustomerForm.controls.password.markAsUntouched();
    // this.addCustomerForm.controls.password.setValidators([]);
    // this.addCustomerForm.controls.password.updateValueAndValidity();
  }
  getPassaword(user) {
    this.commonService.getRequest('multitrack/getMessage/'+user.id, []).then((resp: any) => {
      if (resp?.status) {
       user.password = resp.data && resp.data.data ? resp.data.data : 'Not Found' ;
      }else {
        user.password = 'Not found'
      }
    });
  }
  addAttri(template: TemplateRef<any>) {
    this.addAttr = {
      attribute: '',
      type: '',
      value: null,
    };
    this.modalRef = this.modalService.show(template);
  }

  deleteAttr(key) {
    this.addCustomerForm.attributesList = this.addCustomerForm.attributesList.filter(
      (a, k) => k !== key
    );
  }

  changeAttrEvent(e) {
    let findAttrName = this.attrList.find((a) => a.id === e.value);
    if (findAttrName) {
      this.addAttr.type = findAttrName.type;
    } else {
      this.addAttr.type = '';
    }
  }

  addAttrbute() {
    if (this.addAttr.attribute) {
      let find = this.addCustomerForm.attributesList.find(
        (a) => a.attribute === this.addAttr.attribute
      );
      if (!find) {
        this.addCustomerForm.attributesList.push(this.addAttr);
      }
      this.modalRef?.hide();
    }
  }

  deleteUser(id) {
    console.log('--------- delete', id);
    Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this Customer!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.isConfirmed) {
        let body = {
          deleteuser: true,
          userId: id,
        };
        this.commonService
          .deleteRequest('users/' + id)
          .then((resp) => {
            console.log(resp);
            this.getAllCustomers();
          })
          .catch((e) => {
            this.getAllCustomers();
          });
        Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Customer is safe :)', 'error');
      }
    });
  }
  userNotifications(user, modal) {
    this.modalRef = this.modalService.show(modal);
    this.notificationsMasterList = [];
    console.log('---------', user);
    this.commonService.getRequest('notifications?all=true', []).then((resp: any) => {
      if (resp?.status) {
        this.notificationsMasterList = resp.data;
        this.getUserNotifications(user.id);
      }
    });
  }
  getUserNotifications(userId) {
    this.commonService
      .getRequest('notifications', ['userId=' + userId])
      .then((resp: any) => {
        if (resp?.status) {
          let mappedId = resp.data.map((d: any) => {
            return d.id;
          });
          this.notificationsMasterList.forEach((d: any, k: number) => {
            this.notificationsMasterList[k]['mapUserId'] = userId;
            this.notificationsMasterList[k]['isSelectedDevice'] =
              mappedId.indexOf(d.id) > -1;
          });
          
        }
      });
  }
  assignDevice(user, modal) {
    this.modalRef = this.modalService.show(modal);
    this.deviceList = [];
    console.log('---------', user);
    this.commonService.getRequest('devices', []).then((resp: any) => {
      if (resp?.status) {
        this.deviceList = resp.data;
        this.getUserDevice(user.id);
      }
    });
  }
  getUserDevice(userId) {
    this.commonService
      .getRequest('devices', ['userId=' + userId])
      .then((resp: any) => {
        if (resp?.status) {
          let mappedId = resp.data.map((d: any) => {
            return d.id;
          });
          this.deviceList.forEach((d: any, k: number) => {
            this.deviceList[k]['mapUserId'] = userId;
            this.deviceList[k]['isSelectedDevice'] =
              mappedId.indexOf(d.id) > -1;
          });
          console.log(
            'resp----this.deviceList-------',
            mappedId,
            this.deviceList
          );
        }
      });
  }
  assignUser(customer, modal) {
    this.modalRef = this.modalService.show(modal),
    this.getMappedUsers(customer.id);
  }
  getMappedUsers(dealerId) {
    this.commonService
      .getRequest('users', ['userId=' + dealerId])
      .then((resp: any) => {
        if (resp?.status) {
          let mappedId = resp.data.map((d: any) => {
            return d.id;
          });
          this.usersList.forEach((d: any, k: number) => {
            this.usersList[k]['mapDealerId'] = dealerId;
            this.usersList[k]['isSelectedUser'] =
              mappedId.indexOf(d.id) > -1;
          });
          console.log(
            'resp----this.usersList-------',
            mappedId,
            this.usersList
          );
        }
      });
  }

  changeEvent(e: any, notificationId, userId) {
    if (e.checked) {
      this.commonService
        .postRequest('permissions', {
          userId: userId,
          notificationId: notificationId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    } else {
      this.commonService
        .deleteRequest('permissions', {
          userId: userId,
          notificationId: notificationId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    }
  }
  changeEventDevices(e: any, deviceId, userId) {
    if (e.checked) {
      this.commonService
        .postRequest('permissions', {
          userId: userId,
          deviceId: deviceId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    } else {
      this.commonService
        .deleteRequest('permissions', {
          userId: userId,
          deviceId: deviceId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    }
  }
  changeEventUserMapping(e: any, dealerId, managedUserId) {
    if (e.checked) {
      this.commonService
        .postRequest('permissions', {
          userId: dealerId,
          managedUserId: managedUserId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    } else {
      this.commonService
        .deleteRequest('permissions', {
          userId: dealerId,
          managedUserId: managedUserId,
        })
        .then((resp: any) => {
          if (resp?.status) {
          }
        });
    }
  }

  openModel() {
    this.commonService.commonModel.next(true);
  }

  onCustomerCancel() {
    this.gridMode = true;
    this.addMode = false;
    this.viewMode = false;
  }
  onToggleDisable(customer: any, event: any) {
    Swal.fire({
      title: 'Are you sure want to disable?',
      text: 'User will not able to login into application once disable',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, disable it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.isConfirmed) {
        customer['disabled'] = event.checked;
        this.commonService
        .putRequest('users/' + this.addCustomerForm.id, customer)
        .then((resp: any) => {
          if (resp?.status && resp?.data?.id) {
            //$('#staticBackdrop').modal('hide');
            this.gridMode = true;
            this.addMode = false;
            this.viewMode = false;
            this.getAllCustomers();
          }
        },(err)=>{
          console.log(err);
           Swal.fire({
             icon: "error",
             title: "Something Went Wrong",
             showConfirmButton: false,
             timer: 1500,
           });
         });
        // let body = {
        //   deleteuser: true,
        //   userId: id,
        // };
        // this.user.deleteCustomer(body).subscribe((resp) => {
        //   console.log(resp);
        //   this.gridMode = true;
        //   this.addMode = false;
        //   this.getAllCustomers();
        // });
        Swal.fire('Disabled!', 'User has been disabled.', 'success');
        this.getAllCustomers();
      } else if (result.dismiss === Swal.DismissReason.cancel) {        
        Swal.fire('Cancelled', 'User is safe :)', 'error');
        this.getAllCustomers();
      }
    });
  }
  closeDevicesModal() {
    this.modalRef.hide();
  }
  notificationModalClose() {
    this.modalRef.hide();
  }
  closeUserModal() {
    this.modalRef.hide();
  }
  // getTimezoneList() {
  //   this.commonService.getWorldTimeZoneList().subscribe((result: any) => {
  //     this.timeZoneList = result;
  //   })
  // }

  onFileUpload(event: any, key) {
    //this.selectedFile = event.target.files[0];
    if (event.target.files[0]) {
      this.uploadDocs(event.target.files[0], key);
    } else {
      Swal.fire({
        icon: "error",
        title: "Unsupported File Type. Only xls/xlsx/csv is allowed!",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
  uploadDocs(file, key) {
    if (file) {
      const formData: FormData = new FormData();
      formData.append('files', file);
      this.commonService
        .postRequestForFile('multitrack/uploadfiles', formData)
        .then((resp: any) => {
          if (resp?.status) {
            this.addExtraValues[key] = resp.data;
            // Swal.fire({
            //   icon: "success",
            //   title: `Task data added successfully`,
            //   showConfirmButton: false,
            //   timer: 1500,
            // });
            // this.commonService.commonModel.next(false);
          }
        }, error => {
          Swal.fire({
            icon: "error",
            title: "Something Went Wrong!",
            showConfirmButton: false,
            timer: 1500,
          });
          this.commonService.commonModel.next(false);
        });
    }
  }
  getFileType(file) {
    let extension = file.file.substr(file.file.length - 7, file.file.length);
    if (extension.toLowerCase().indexOf('jpeg') >= 0 || extension.toLowerCase().indexOf('png') >= 0 || extension.toLowerCase().indexOf('jpg') >= 0) {
      return `image`;
    } else if (extension.toLowerCase().indexOf('pdf') >= 0) {
      return `pdf`;
    } else {
      return `other`;
    }
    //let fileType = file.file;
  }
  getFileURL(file) {
    //{{envData.apiUrl}}multitrack/downloadfile/{{addExtraValues.medicalproof[0].id}}
    let extension = file.file.substr(file.file.length - 7, file.file.length);
    if (extension.toLowerCase().indexOf('jpeg') >= 0 || extension.toLowerCase().indexOf('png') >= 0 || extension.toLowerCase().indexOf('jpg') >= 0) {
      return `${this.envData.apiUrl}multitrack/downloadfile/${file.id}`;
    } 
    // else if (extension.toLowerCase().indexOf('pdf') >= 0) {
    //   return `${this.envData.apiUrl}multitrack/downloadfile/${file.id}`;
    // } else {
    //   return `${this.envData.apiUrl}multitrack/downloadfile/${file.id}`;
    // }
    //let fileType = file.file;
  }
  ngAfterViewInit() {
    
    
  }
  findAdress(){
    setTimeout(() => {
      this.mapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
          types: ["address"]
        });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
  
            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
  
            //set latitude, longitude and zoom
            this.latitude = place.geometry.location.lat();
            this.longitude = place.geometry.location.lng();
            this.zoom = 12;
            console.log(`${place.formatted_address}
            ${place.website}
            ${place.name}
            ${place.address_components[place.address_components.length - 1].long_name}`);
          });
        });
      });
    }, 4000);
    
    // this.mapsAPILoader.load().then(() => {
    //      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    //      autocomplete.addListener("place_changed", () => {
    //        this.ngZone.run(() => {
    //          // some details
    //          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
    //         //  this.address = place.formatted_address;
    //         //  this.web_site = place.website;
    //         //  this.name = place.name;
    //         //  this.zip_code = place.address_components[place.address_components.length - 1].long_name;
    //         //  //set latitude, longitude and zoom
    //         //  this.latitude = place.geometry.location.lat();
    //         //  this.longitude = place.geometry.location.lng();
    //         //  this.zoom = 12;
    //        });
    //      });
    //    });
   }

   
  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  resizeMap() {
    setTimeout(() => {
      this.mapslocation.triggerResize();  
    }, 4000);
    
  }
  markerDragEnd($event: any) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.searchControl.patchValue(this.latitude +', '+ this.longitude);
    //this.getAddress(this.latitude, this.longitude);
  }
}
